/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import type {
  ApproveScheduleSiteChangeRequest,
  CancelScheduleSiteChangeRequest,
  ChangeRequestByDateRangeDto,
  CreateChangeRequestByDateRange,
  ReviseSiteScheduleChangeRequest,
  SaveScheduleSiteChangeRequest,
  ScheduleSiteChangeRequestDto,
  SubmitScheduleSiteChangeRequest
} from '../models';

import { customInstance } from '../axios';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * @summary CreateChangeRequestByDateRange
 */
export const createChangeRequestByDateRange = (
    createChangeRequestByDateRange: CreateChangeRequestByDateRange,
 options?: SecondParameter<typeof customInstance<ChangeRequestByDateRangeDto>>,) => {
      return customInstance<ChangeRequestByDateRangeDto>(
      {url: `/deployment/site-schedule-change-requests/create`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createChangeRequestByDateRange
    },
      options);
    }
  /**
 * @summary SaveScheduleSiteChangeRequest
 */
export const saveScheduleSiteChangeRequest = (
    id: string,
    saveScheduleSiteChangeRequest: SaveScheduleSiteChangeRequest,
 options?: SecondParameter<typeof customInstance<ScheduleSiteChangeRequestDto>>,) => {
      return customInstance<ScheduleSiteChangeRequestDto>(
      {url: `/deployment/site-schedule-change-requests/${id}/save`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: saveScheduleSiteChangeRequest
    },
      options);
    }
  export const submitSiteScheduleChangeRequests = (
    id: string,
    submitScheduleSiteChangeRequest: SubmitScheduleSiteChangeRequest,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/deployment/site-schedule-change-requests/${id}/submit`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: submitScheduleSiteChangeRequest
    },
      options);
    }
  export const approveSiteScheduleChangeRequests = (
    id: string,
    approveScheduleSiteChangeRequest: ApproveScheduleSiteChangeRequest,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/deployment/site-schedule-change-requests/${id}/approve`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: approveScheduleSiteChangeRequest
    },
      options);
    }
  export const cancelSiteScheduleChangeRequests = (
    id: string,
    cancelScheduleSiteChangeRequest: CancelScheduleSiteChangeRequest,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/deployment/site-schedule-change-requests/${id}/cancel`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: cancelScheduleSiteChangeRequest
    },
      options);
    }
  export const reviseSiteScheduleChangeRequests = (
    id: string,
    reviseSiteScheduleChangeRequest: ReviseSiteScheduleChangeRequest,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/deployment/site-schedule-change-requests/${id}/revise`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: reviseSiteScheduleChangeRequest
    },
      options);
    }
  export type CreateChangeRequestByDateRangeResult = NonNullable<Awaited<ReturnType<typeof createChangeRequestByDateRange>>>
export type SaveScheduleSiteChangeRequestResult = NonNullable<Awaited<ReturnType<typeof saveScheduleSiteChangeRequest>>>
export type SubmitSiteScheduleChangeRequestsResult = NonNullable<Awaited<ReturnType<typeof submitSiteScheduleChangeRequests>>>
export type ApproveSiteScheduleChangeRequestsResult = NonNullable<Awaited<ReturnType<typeof approveSiteScheduleChangeRequests>>>
export type CancelSiteScheduleChangeRequestsResult = NonNullable<Awaited<ReturnType<typeof cancelSiteScheduleChangeRequests>>>
export type ReviseSiteScheduleChangeRequestsResult = NonNullable<Awaited<ReturnType<typeof reviseSiteScheduleChangeRequests>>>
